<template>
        <div class="TxProductStats" v-if="stats.status !== false" v-html="stats.stats_html"> </div>
</template>
<script>
    export default {
        name: 'TxProductStats',
        data() {
            return {
                stats: false,
            }
        },
        async mounted() {
            if (this.$root.env === 'frontend') {
              await this.getStats();
              document.body.querySelector('.woocommerce-variation-add-to-cart').appendChild(this.$el);
            }
        },
        methods: {
            async getStats() {
                try {
                    let {data} = await this.$http({
                        method: 'GET',
                        url: `${this.wp_rest}lm/v1/lovemap/stats/${this.product_id}`,
                    });
                    if (data.status === true){
                        data.stats_html = data.stats_html.toString().replace(/\[(\s*tx-prod-sales*)\]/g, data.stats);
                        this.stats = data
                    }
                } catch (e) {
                    console.error(e)
                }
            }
        },
        computed:{
            wp_rest(){
                return lovemap.rest
            },
            product_id(){
                return lovemap.product_id
            }
        },
    }
</script>

<style>
        .TxProductStats{
                float: left;
                padding-top: 25px;
        }
</style>
